import Vue from 'vue'
import Router from 'vue-router'
// import List from '../components/List.vue'

Vue.use(Router);

export default new Router({
  // mode: 'history',
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    }
    return { x: 0, y: 0 }
  },
  routes: [

    // 登录页面


    {
      path: '/LoginWx',
      component: () =>
        import('../page/LoginWx.vue'),
      meta: { keepAlive: false, title: '微信登录' },
      name: "LoginWx",
      needLogin: true
    },
    {
      path: '/BindMobileNumber',
      component: () =>
        import('../page/page(new)/BindMobileNumber.vue'),
      meta: { keepAlive: false, title: '绑定手机号' },
      name: "BindMobileNumber"
    },
    {
      path: '/MobileLogin',
      component: () =>
        import('../page/page(new)/MobileLogin.vue'),
      meta: { keepAlive: false, title: '手机登录' },
      name: "MobileLogin"
    },
    {
      path: '/MobileRegister',
      component: () =>
        import('../page/page(new)/MobileRegister.vue'),
      meta: { keepAlive: false, title: '手机注册' },
      name: "MobileRegister",
    },
    {
      path: '/PawRegister/:mobile',
      component: () =>
        import('../page/page(new)/PawRegister.vue'),
      meta: { keepAlive: false, title: '手机注册' },
      name: "PawRegister"
    },
    {
      path: '/MobileForgetPwd',
      component: () =>
        import('../page/page(new)/MobileForgetPwd.vue'),
      meta: { keepAlive: false, title: '找回密码' },
      name: "MobileForgetPwd"
    },
    {
      path: '/newForgetPwd',
      component: () =>
        import('../page/page(new)/newForgetPwd.vue'),
      meta: { keepAlive: false, title: '找回密码' },
      name: "newForgetPwd"
    },
    {
      path: '/orderinventory/:cid',
      component: () =>
        import('../page/Orderinventory.vue'),
      meta: { keepAlive: false, title: '订单盘点' },
      name: 'orderinventory'
    },
    {
      path: '/actionsheet',
      component: () =>
        import('../demo/actionsheet.vue'),
      meta: { keepAlive: false, title: 'actionsheet' },
      name: 'actionseet'
    },

    //diy首页
    {
      path: '/diyHome',
      component: () =>
        import('../diy/diyHome.vue'),
      meta: { keepAlive: false, title: 'diyHome' },
      name: 'diyHome'
    },

    {
      path: '/openid',
      component: () =>
        import('../demo/openid.vue'),
      meta: { keepAlive: false, title: 'openid' },
      name: 'openid'
    },
    {
      path: '/pi1',
      component: () =>
        import('../demo/pi1.vue'),
      meta: { keepAlive: false, title: '首页' },
      name: 'pi1'
    },
    {
      path: '/',
      redirect: "/startupPage",
      meta: { keepAlive: false, },
    },
    {
      path: '/startupPage',
      component: () =>
        import('../page/startupPage.vue'),
      meta: { keepAlive: false, },
      name: "startupPage",
      needLogin: true
    },
    {
      path: '/selectLoginType',
      component: () =>
        import('../page/selectLoginType.vue'),
      meta: { keepAlive: false, },
      name: "selectLoginType",
      needLogin: true
    },
    //扫码进入电池型号查询页面
    {
      path: '/modelNumQuery',
      component: () =>
        import('../page/modelNumQuery.vue'),
      meta: { keepAlive: false, title: '型号查询' },
      name: "modelNumQuery",
      needLogin: true
    },

    // {
    //   path:'/',
    //   redirect:"/Login",
    //   meta:{keepAlive:false,title:'登录'},
    // },


    {
      path: '/Home',
      component: () =>
        import('../components/Home.vue'),
      meta: { keepAlive: false, title: '首页' },
      name: 'Home'
    },
    {
      path: '/goodsList',
      // component:List,
      component: () =>
        import('../components/List.vue'),
      meta: { keepAlive: false, title: '分类' },
      name: "List"
    },
    {
      path: '/List',
      // component:List,
      component: () =>
        import('../goods/goodsList.vue'),
      meta: { keepAlive: false, title: '分类' },
      name: "goodsList"
    },
    // {
    // path:'/List/:nip',
    // component:()=>import('../components/List.vue'),
    // meta:{keepAlive:true,title:'分类'},
    // name:"List"
    // },
    {
      path: '/ReturnList/:type',
      // component:List,
      component: () =>
        import('../goods/returnTheGoods.vue'),
      meta: { keepAlive: false, title: '分类' },
      name: "returnTheGoods"
    },
    {
      path: '/Service',
      component: () =>
        import('../components/Service.vue'),
      meta: { keepAlive: true, title: '客服' },
      name: "Service"
    },
    {
      path: '/Car',
      component: () =>
        import('../components/Car.vue'),
      meta: { keepAlive: false, title: '购物车' },
      name: "Car"
    },
    {
      path: '/ReturnCar/:type',
      component: () =>
        import('../components/ReturnCar.vue'),
      meta: { keepAlive: false, title: '退货车' },
      name: "ReturnCar"
    },
    {
      path: '/User',
      component: () =>
        import('../components/User.vue'),
      meta: { keepAlive: true, title: '我的', needrouter: true },
      name: "User"
    },

    {
      path: '/navClass/:navId',
      component: () =>
        import('../page/navClass.vue'),
      meta: { keepAlive: false, title: '导航商品' },
      name: "navClass"
    },
    {
      path: '/SearchProduce',
      component: () =>
        import('../page/SearchProduce.vue'),
      meta: { keepAlive: true, title: '搜索' },
      name: "SearchProduce"
    },
    {
      path: '/Produce/:pid',
      component: () =>
        import('../page/Produce.vue'),
      meta: { title: '商品详情' },
      name: "Produce"
    },
    {
      path: '/zeroShopProduce/:pid',
      component: () =>
        import('../page/zeroShopProduce.vue'),
      meta: { title: '零元商城商品详情' },
      name: "zeroShopProduce"
    },
    {
      path: '/groupProduce/:group_id',
      component: () =>
        import('../page/groupProduce.vue'),
      meta: { title: '组合商品详情' },
      name: "groupProduce"
    },

    {
      path: '/Set',
      component: () =>
        import('../page/Set.vue'),
      meta: { keepAlive: true, title: '设置' },
      name: "Set"
    },
    {
      path: '/Personage',
      component: () =>
        import('../page/Personage.vue'),
      meta: { keepAlive: true, title: '个人资料' },
      name: "Personage"
    },
    {
      path: '/SetPassword',
      component: () =>
        import('../page/SetPassword.vue'),
      meta: { keepAlive: true, title: '修改密码' },
      name: "SetPassword"
    },
    {
      path: '/Address',
      component: () =>
        import('../page/Address.vue'),
      meta: { keepAlive: false, title: '收货地址' },
      name: "Address"
    },
    {
      path: '/Feedback',
      component: () =>
        import('../page/Feedback.vue'),
      meta: { keepAlive: true, title: '意见反馈' },
      name: "Feedback"
    },
    {
      path: '/zeroShop',
      component: () =>
        import('../page/zeroShop.vue'),
      meta: { keepAlive: true, title: '零元商城' },
      name: "zeroShop"
    },
    {
      path: '/AddressEditor',
      component: () =>
        import('../page/AddressEditor.vue'),
      meta: { keepAlive: false, title: '地址编辑' },
      name: "AddressEditor"
    },
    {
      path: '/addClientEditor',
      component: () =>
        import('../page/addClientEditor.vue'),
      meta: { keepAlive: false, title: '客户编辑' },
      name: "addClientEditor"
    },
    {
      path: '/addAddress',
      component: () =>
        import('../page/addAddress.vue'),
      meta: { keepAlive: false, title: '地址' },
      name: "addAddress"
    },
    {
      path: '/Obligation',
      component: () =>
        import('../page/Obligation.vue'),
      meta: { keepAlive: false, title: '订单' },
      name: "Obligation"
    },
    {
      path: '/ConfirmOrder/:pid',
      component: () =>
        import('../page/ConfirmOrder.vue'),
      meta: { keepAlive: false, title: '确认订单' },
      name: "ConfirmOrder"
    },
    {
      path: '/ConfirmGroupOrder/:group_id/:number',
      component: () =>
        import('../page/ConfirmGroupOrder.vue'),
      meta: { keepAlive: false, title: '确认订单' },
      name: "ConfirmGroupOrder"
    },
    {
      path: '/ConfirmReturnOrder/:type',
      component: () =>
        import('../page/ConfirmReturnOrder.vue'),
      meta: { keepAlive: false, title: '确认订单' },
      name: "ConfirmReturnOrder"
    },
    {
      path: '/CommodityList/:order_id',
      component: () =>
        import('../page/CommodityList.vue'),
      meta: { keepAlive: false, title: '商品清单' },
      name: "CommodityList"
    },
    {
      path: '/CommodGroupList',
      component: () =>
        import('../page/CommodGroupList.vue'),
      meta: { keepAlive: false, title: '商品清单' },
      name: "CommodGroupList"
    },
    {
      path: '/ReturnCommodityList',
      component: () =>
        import('../page/ReturnCommodityList.vue'),
      meta: { keepAlive: false, title: '退货商品清单' },
      name: "ReturnCommodityList"
    },
    {
      path: '/Pay/:orderId/:price',
      component: () =>
        import('../page/Pay.vue'),
      meta: { keepAlive: false, title: '确认支付' },
      name: "Pay"
    },
    {
      path: '/orderPay',
      component: () =>
        import('../order/pay.vue'),
      meta: { keepAlive: false, title: '确认支付' },
      name: "orderPay"
    },
        {
      path: '/orderPay1',
      component: () =>
        import('../order/pay1.vue'),
      meta: { keepAlive: false, title: '测试支付' },
      name: "orderPay1"
    },
    {
      path: '/pay_success',
      component: () =>
        import('../page/paysuccess.vue'),
      meta: { keepAlive: false, title: '支付成功' },
      name: "pay_success"
    },
    {
      path: '/Pay/:orderId/:price/:type',
      component: () =>
        import('../page/Pay.vue'),
      meta: { keepAlive: false, title: '确认支付' },
      name: "Pay"
    },
    {
      path: '/ReturnPay/:orderId',
      component: () =>
        import('../page/ReturnPay.vue'),
      meta: { keepAlive: false, title: '确认退款' },
      name: "ReturnPay"
    },
    {
      path: '/pageReturnOrder/Pay/:orderId',
      component: () =>
        import('../pageSales/pageReturnOrder/Pay.vue'),
      meta: { keepAlive: false, title: '退款' },
      name: "pageReturnOrderPay"
    },
    {
      path: '/pageReturnOrder/payFinanceReturn/:orderId',
      component: () =>
        import('../pageSales/pageReturnOrder/PayFinanceReturn.vue'),
      meta: { keepAlive: false, title: '财务退款' },
      name: "payFinanceReturn"
    },
    {
      path: '/pageReturnOrder/payCashReturn/:orderId',
      component: () =>
        import('../pageSales/pageReturnOrder/PayCashReturn.vue'),
      meta: { keepAlive: false, title: '现金退款' },
      name: "pageCashReturn"
    },
    {
      path: '/pageReturnOrder/salesReturnOrder/:orderId',
      component: () =>
        import('../pageSales/pageReturnOrder/SalesReturnOrder.vue'),
      meta: { keepAlive: false, title: '销售退货单' },
      name: "salesReturnOrder"
    },
    {
      path: '/ReplacePay',
      component: () =>
        import('../page/ReplacePay.vue'),
      meta: { keepAlive: false, title: '代下单' },
      name: "ReplacePay"
    },
    {
      path: '/ClientType',
      component: () =>
        import('../page/ClientType.vue'),
      meta: { keepAlive: false, title: '客户类型' },
      name: "ClientType"
    },
    {
      path: '/ClientType1',
      component: () =>
        import('../page/ClientType1.vue'),
      meta: { keepAlive: false, title: '客户类型' },
      name: "ClientType1"
    },
    {
      path: '/ClientTypeEditor/:ClientTypeEditorId',
      component: () =>
        import('../page/ClientTypeEditor.vue'),
      meta: { keepAlive: false, title: '客户类型' },
      name: "ClientTypeEditor"
    },
    {
      path: '/gender',
      component: () =>
        import('../page/gender.vue'),
      meta: { keepAlive: false, title: '选择性别' },
      name: "gender"
    },
    {
      path: '/gender1',
      component: () =>
        import('../page/gender1.vue'),
      meta: { keepAlive: false, title: '选择性别' },
      name: "gender1"
    },
    {
      path: '/genderEditor/:genderEditorId',
      component: () =>
        import('../page/genderEditor.vue'),
      meta: { keepAlive: false, title: '选择性别' },
      name: "genderEditor"
    },
    {
      path: '/mainItemEditor/:mainItemEditorId',
      component: () =>
        import('../page/mainItemEditor.vue'),
      meta: { keepAlive: false, title: '主营行业' },
      name: "mainItemEditor"
    },
    {
      path: '/addClient',
      component: () =>
        import('../page/addClient.vue'),
      meta: { keepAlive: false, title: '新客户' },
      name: "addClient"
    },
    {
      path: '/newClient',
      component: () =>
        import('../page/newClient.vue'),
      meta: { keepAlive: false, title: '添加新客户' },
      name: "newClient"
    },
    {
      path: '/editClient',
      component: () =>
        import('../page/editClient.vue'),
      meta: { keepAlive: false, title: '编辑客户' },
      name: "editClient"
    },
    {
      path: '/addVisitClient',
      component: () =>
        import('../page/addVisitClient.vue'),
      meta: { keepAlive: false, title: '新建客户' },
      name: "addVisitClient"
    },
    {
      path: '/mainItem',
      component: () =>
        import('../page/mainItem.vue'),
      meta: { keepAlive: false, title: '主营行业' },
      name: "mainItem"
    },
    {
      path: '/mainItem1',
      component: () =>
        import('../page/mainItem1.vue'),
      meta: { keepAlive: false, title: '主营行业' },
      name: "mainItem1"
    },
    {
      path: '/readlyName',
      component: () =>
        import('../page/readlyName.vue'),
      meta: { keepAlive: true, title: '实名认证' },
      name: "readlyName",
    },
    {
      path: '/OrderDetail/:order_id',
      component: () =>
        import('../page/OrderDetail.vue'),
      meta: { keepAlive: false, title: '订单详情' },
      name: "OrderDetail"
    },
    {
      path: '/Salesman',
      component: () =>
        import('../page/Salesman.vue'),
      meta: { keepAlive: false, title: '跟进员' },
      name: "Salesman"
    },
    {
      path: '/Salesman1',
      component: () =>
        import('../page/Salesman1.vue'),
      meta: { keepAlive: false, title: '跟进员' },
      name: "Salesman1"
    },
    {
      path: '/ClientSource',
      component: () =>
        import('../page/ClientSource.vue'),
      meta: { keepAlive: true, title: '客户来源' },
      name: "ClientSource"
    },
    {
      path: '/ClientSource_new',
      component: () =>
        import('../page/ClientSource_new.vue'),
      meta: { keepAlive: true, title: '客户来源' },
      name: "ClientSource_new"
    },
    {
      path: '/ClientSource1',
      component: () =>
        import('../page/ClientSource1.vue'),
      meta: { keepAlive: true, title: '客户来源' },
      name: "ClientSource1"
    },
    {
      path: '/entrepot',
      component: () =>
        import('../page/entrepot.vue'),
      meta: { keepAlive: true, title: '发货仓库' },
      name: "entrepot"
    },
    {
      path: '/ClientGrade',
      component: () =>
        import('../page/ClientGrade.vue'),
      meta: { keepAlive: true, title: '客户级别' },
      name: "ClientGrade"
    },
    {
      path: '/position',
      component: () =>
        import('../page/position.vue'),
      meta: { keepAlive: true, title: '职务' },
      name: "position"
    },
    {
      path: '/ClientGrade_new',
      component: () =>
        import('../page/ClientGrade_new.vue'),
      meta: { keepAlive: true, title: '客户级别' },
      name: "ClientGrade_new"
    },
    {
      path: '/ClientGrade1',
      component: () =>
        import('../page/ClientGrade1.vue'),
      meta: { keepAlive: true, title: '客户级别' },
      name: "ClientGrade1"
    },
    {
      path: '/SourceEdior/:SourceEdiorId',
      component: () =>
        import('../page/SourceEdior.vue'),
      meta: { keepAlive: false, title: '客户来源' },
      name: "SourceEdior"
    },
    {
      path: '/GradeEdior/:GradeEdiorId',
      component: () =>
        import('../page/GradeEdior.vue'),
      meta: { keepAlive: false, title: '客户级别' },
      name: "GradeEdior"
    },
    {
      path: '/SalesEdior/:SalesEdiorId',
      component: () =>
        import('../page/SalesEdior.vue'),
      meta: { keepAlive: false, title: '所属跟进员' },
      name: "SalesEdior"
    },
    {
      path: '/SuccessPay/:payprice',
      component: () =>
        import('../page/SuccessPay.vue'),
      meta: { keepAlive: false, title: '支付成功' },
      name: "SuccessPay"
    },
    {
      path: '/forgetPwd',
      component: () =>
        import('../page/forgetPwd.vue'),
      meta: { keepAlive: false, title: '找回密码' },
      name: "forgetPwd",
      needLogin: true
    },
    {
      path: '/LoginAgree',
      component: () =>
        import('../page/LoginAgree.vue'),
      meta: { keepAlive: false, title: '用户服务协议' },
      name: "LoginAgree",
      needLogin: true
    },
    {
      path: '/LoginPrivacy',
      component: () =>
        import('../page/LoginPrivacy.vue'),
      meta: { keepAlive: false, title: '用户隐私政策' },
      name: "LoginPrivacy",
      needLogin: true
    },
    {
      path: '/register',
      component: () =>
        import('../login/register.vue'),
      meta: { keepAlive: false, title: '注册' },
      name: "register",
      needLogin: true
    },
    {
      path: '/About',
      component: () =>
        import('../page/About.vue'),
      meta: { keepAlive: true, title: '关于我们' },
      name: "About",

    },
    {
      path: '/contactUs',
      component: () =>
        import('../page/contactUs.vue'),
      meta: { keepAlive: true, title: '联系我们' },
      name: "contactUs",

    },
    {
      path: '/mybill',
      component: () =>
        import('../bill/Mybill.vue'),
      meta: { keepAlive: true, title: '我的账单' },
      name: "Mybill",
    },
    {
      path: '/mybill/billd',
      component: () =>
        import('../bill/Billd.vue'),
      meta: { keepAlive: true, title: '订单明细表' },
      name: "Billd",
    },
    {
      path: '/express',
      component: () =>
        import('../page/Express.vue'),
      meta: { keepAlive: true, title: '订单明细表' },
      name: "Express",
    },
    {
      path: '/account',
      component: () =>
        import('../bill/Account.vue'),
      meta: { keepAlive: true, title: '订单明细新表' },
      name: "Accont",
    },
    {
      path: '/balance',
      component: () =>
        import('../bill/Balance.vue'),
      meta: { keepAlive: true, title: '支付欠款' },
      name: "Balance",
    },
    {
      path: '/orderRecord',
      component: () =>
        import('../page/orderRecord.vue'),
      meta: { keepAlive: true, title: '发货记录' },
      name: "orderRecord",
    },
    {
      path: '/payCode/:orderId/:allPrice/:type',
      component: () =>
        import('../page/payCode.vue'),
      meta: { keepAlive: false, title: '付款码' },
      name: "payCode",
    },

    //提现
    {
      path: '/widthdraw',
      component: () =>
        import('../page/bankCard/widthdraw.vue'),
      meta: { keepAlive: false, title: '提现银行卡' },
      name: "widthdraw"
    },
    {
      path: '/advanceDeposit',
      component: () =>
        import('../page/bankCard/advanceDeposit.vue'),
      meta: { keepAlive: false, title: '转入预存款' },
      name: "advanceDeposit"
    },
    {
      path: '/wechatDrawal',
      component: () =>
        import('../page/bankCard/wechatDrawal.vue'),
      meta: { keepAlive: false, title: '微信提现' },
      name: "wechatDrawal"
    },
    {
      path: '/cardlList',
      component: () =>
        import('../page/bankCard/cardlList.vue'),
      meta: { keepAlive: false, title: '银行卡' },
      name: "cardlList"
    },
    {
      path: '/walletRecord',
      component: () =>
        import('../page/bankCard/walletRecord.vue'),
      meta: { keepAlive: false, title: '钱包记录' },
      name: "walletRecord"
    },
    {
      path: '/myCard',
      component: () =>
        import('../page/bankCard/myCard.vue'),
      meta: { keepAlive: false, title: '选择账户' },
      name: "myCard"
    },
    {
      path: '/addCard',
      component: () =>
        import('../page/bankCard/addCard.vue'),
      meta: { keepAlive: false, title: '添加银行卡' },
      name: "addCard"
    },
    {
      path: '/addAliPay',
      component: () =>
        import('../page/bankCard/addAliPay.vue'),
      meta: { keepAlive: false, title: '添加支付宝' },
      name: "addAliPay"
    },
    {
      path: '/chooseDrawal',
      component: () =>
        import('../page/bankCard/chooseDrawal.vue'),
      meta: { keepAlive: false, title: '提现' },
      name: "chooseDrawal"
    },

    //业务端

    {
      path: '/confirmPay/:orderId/:price',
      component: () =>
        import('../page/confirmPay.vue'),
      meta: { keepAlive: false, title: '确认付款' },
      name: "confirmPay"
    },
    {
      path: '/SalesHome',
      component: () =>
        import('../componentsSales/SalesHome.vue'),
      meta: { keepAlive: false, title: '工作台' },
      name: "SalesHome"
    },
    {
      path: '/SalesClient',
      component: () =>
        import('../componentsSales/SalesClient.vue'),
      meta: { keepAlive: false, title: '客户' },
      name: "SalesClient"
    },
    {
      path: '/SalesOrder',
      component: () =>
        import('../order/orderList.vue'),
      meta: { keepAlive: false, title: '订单' },
      name: "SalesOrder"
    },
    // {
    //   path: '/SalesOrder',
    //   component: () =>
    //     import('../componentsSales/SalesOrder.vue'),
    //   meta: { keepAlive: false, title: '订单' },
    //   name: "SalesOrder"
    // },
    {
      path: '/SalesNews',
      component: () =>
        import('../componentsSales/SalesNews.vue'),
      meta: { keepAlive: true, title: '消息' },
      name: "SalesNews"
    },
    {
      path: '/billNews',
      component: () =>
        import('../pageSales/billNews.vue'),
      meta: { keepAlive: false, title: '账单消息' },
      name: "billNews"
    },
    {
      path: '/getComment',
      component: () =>
        import('../pageSales/getComment.vue'),
      meta: { keepAlive: false, title: '收到的评论' },
      name: "getComment"
    },
    {
      path: '/followRemind',
      component: () =>
        import('../pageSales/followRemind.vue'),
      meta: { keepAlive: false, title: '客户跟进提醒' },
      name: "followRemind"
    },
    {
      path: '/systemNoticeDetail/:systemNoticeDetailId',
      component: () =>
        import('../pageSales/systemNoticeDetail.vue'),
      meta: { keepAlive: false, title: '系统公告详情' },
      name: "systemNoticeDetail"
    },
    {
      path: '/messageDetail',
      component: () =>
        import('../pageSales/messageDetail.vue'),
      meta: { keepAlive: false, title: '小助理' },
      name: "messageDetail"
    },
    {
      path: '/SalesMore',
      component: () =>
        import('../componentsSales/SalesMore.vue'),
      meta: { keepAlive: false, title: '更多' },
      name: "SalesMore"
    },
    {
      path: '/personalStore',
      component: () =>
        import('../pageSales/personalStore.vue'),
      meta: { keepAlive: false, title: '个仓配送' },
      name: "personalStore"
    },
    //仓库start**************************************************************
    {
      path: '/personalStore_new',
      component: () =>
        import('../pageSales/personalStore_new.vue'),
      meta: { keepAlive: false, title: '个仓配送' },
      name: "personalStore_new"
    },
    //仓库end****************************************************************



    {
      path: '/WorkReport',
      component: () =>
        import('../pageSales/WorkReport.vue'),
      meta: { keepAlive: false, title: '工作汇报' },
      name: "WorkReport"
    },
    {
      path: '/WorkReportRecord',
      component: () =>
        import('../pageSales/WorkReportRecord.vue'),
      meta: { keepAlive: false, title: '工作汇报记录' },
      name: "WorkReport"
    },
    {
      path: '/WorkReportDay',
      component: () =>
        import('../pageSales/WorkReportDay.vue'),
      meta: { keepAlive: false, title: '工作汇报—日报' },
      name: "WorkReportDay"
    },
    {
      path: '/WorkReportWeek',
      component: () =>
        import('../pageSales/WorkReportWeek.vue'),
      meta: { keepAlive: false, title: '工作汇报—周报' },
      name: "WorkReportWeek"
    },
    {
      path: '/WorkReportMonth',
      component: () =>
        import('../pageSales/WorkReportMonth.vue'),
      meta: { keepAlive: false, title: '工作汇报—月报' },
      name: "WorkReportMonth"
    },
    {
      path: '/WorkReportSale',
      component: () =>
        import('../pageSales/WorkReportSale.vue'),
      meta: { keepAlive: false, title: '工作汇报—销售业绩' },
      name: "WorkReportSale"
    },
    {
      path: '/WorkReportBusiness',
      component: () =>
        import('../pageSales/WorkReportBusiness.vue'),
      meta: { keepAlive: false, title: '工作汇报—营业报告' },
      name: "WorkReportBusiness"
    },
    {
      path: '/WorkReportVisit',
      component: () =>
        import('../pageSales/WorkReportVisit.vue'),
      meta: { keepAlive: false, title: '工作汇报—拜访记录' },
      name: "WorkReportVisit"
    },
    {
      path: '/WorkReportDetail/:id',
      component: () =>
        import('../pageSales/WorkReportDetail.vue'),
      meta: { keepAlive: false, title: '工作汇报—祥情' },
      name: "WorkReportDetail"
    },
    {
      path: '/Workflow',
      component: () =>
        import('../pageSales/Workflow.vue'),
      meta: { keepAlive: false, title: '考勤' },
      name: "Workflow"
    },
    {
      path: '/guest_warn',
      component: () =>
        import('../pageSales/guest_warn.vue'),
      meta: { keepAlive: false, title: '客户预警' },
      name: "guest_warn"
    },
    // 此页面代表功能未完善
    {
      path: '/Workflow_old',
      component: () =>
        import('../pageSales/Workflow_old.vue'),
      meta: { keepAlive: false, title: '功能未完善' },
      name: "Workflow_old"
    },
    // 此页面代表功能未完善
    {
      path: '/clocking_inremind',
      component: () =>
        import('../pageSales/clocking_inremind.vue'),
      meta: { keepAlive: false, title: '考勤提醒' },
      name: "clocking_inremind"
    },
    {
      path: '/ReplaceExit',
      component: () =>
        import('../pageSales/ReplaceExit.vue'),
      meta: { keepAlive: false, title: '代客退单' },
      name: "ReplaceExit"
    },
    {
      path: '/pageReturnOrder/changeOrder',
      component: () =>
        import('../pageSales/pageReturnOrder/changeOrder.vue'),
      meta: { keepAlive: false, title: '新建销售退货单' },
      name: "pageReturnOrderChangeOrder"
    },
    {
      path: '/pageReturnOrder/valetReturnOrder',
      component: () =>
        import('../pageSales/pageReturnOrder/valetReturnOrder.vue'),
      meta: { keepAlive: false, title: '代客退货单' },
      name: "valetReturnOrder"
    },
    {
      path: '/pageReturnOrder/selectDocument/:type',
      component: () =>
        import('../pageSales/pageReturnOrder/selectDocument.vue'),
      meta: { keepAlive: false, title: '选择单据' },
      name: "selectDocument"
    },
    {
      path: '/pageReturnOrder/selectProducts/:orderNo',
      component: () =>
        import('../pageSales/pageReturnOrder/selectProducts.vue'),
      meta: { keepAlive: false, title: '选择商品' },
      name: "selectProducts"
    },
    {
      path: '/pageReturnOrder/changeWarehouse',
      component: () =>
        import('../pageSales/pageReturnOrder/changeWarehouse.vue'),
      meta: { keepAlive: false, title: '选择仓库' },
      name: "changeWarehouse"
    },
    {
      path: '/backType',
      component: () =>
        import('../pageSales/backType.vue'),
      meta: { keepAlive: false, title: '选择退单形式' },
      name: "backType"
    },
    {
      path: '/ExpenseBill',
      component: () =>
        import('../pageSales/ExpenseBill.vue'),
      meta: { keepAlive: false, title: '报销单' },
      name: "ExpenseBill"
    },
    {
      path: '/TeamMember',
      component: () =>
        import('../pageSales/TeamMember.vue'),
      meta: { keepAlive: false, title: '团队成员' },
      name: "TeamMember"
    },
    {
      path: '/WorkVisit',
      component: () =>
        import('../pageSales/WorkVisit.vue'),
      meta: { keepAlive: false, title: '外勤拜访' },
      name: "WorkVisit"
    },
    {
      path: '/WorkSalesmanVisit/:time/:salesman_id',
      component: () =>
        import('../pageSales/WorkSalesmanVisit.vue'),
      meta: { keepAlive: false, title: '跟进记录明细' },
      name: "WorkSalesmanVisit"
    },
    {
      path: '/fieldVisit/visitRecord',
      component: () =>
        import('../pageSales/fieldVisit/visitRecord.vue'),
      meta: { keepAlive: false, title: '跟进记录列表' },
      name: "VisitRecord"
    },
    {
      path: '/fieldVisit/visitPeopleRecord/:time',
      component: () =>
        import('../pageSales/fieldVisit/visitPeopleRecord.vue'),
      meta: { keepAlive: false, title: '跟进记录日统计' },
      name: "VisitPeopleRecord"
    },
    {
      path: '/fieldVisit/visitAllRecord',
      component: () =>
        import('../pageSales/fieldVisit/visitAllRecord.vue'),
      meta: { keepAlive: false, title: '跟进记录列表' },
      name: "VisitAllRecord"
    },
    {
      path: '/fieldVisit/workVisitList/:time',
      component: () =>
        import('../pageSales/fieldVisit/workVisitList.vue'),
      meta: { keepAlive: false, title: '跟进记录列表' },
      name: "WorkVisitList"
    },
    {
      path: '/visitClient',
      component: () =>
        import('../pageSales/visitClient.vue'),
      meta: { keepAlive: false, title: '选择我的客户' },
      name: "visitClient"
    },
    {
      path: '/VisitTip',
      component: () =>
        import('../pageSales/VisitTip.vue'),
      meta: { keepAlive: false, title: '回访提醒' },
      name: "VisitTip"
    },
    {
      path: '/systemNotice',
      component: () =>
        import('../pageSales/systemNotice.vue'),
      meta: { keepAlive: false, title: '回访提醒' },
      name: "systemNotice"
    },
    {
      path: '/visitTipDetail',
      component: () =>
        import('../pageSales/visitTipDetail.vue'),
      meta: { keepAlive: false, title: '提醒详情' },
      name: "visitTipDetail"
    },
    {
      path: '/ClientAnalyze',
      component: () =>
        import('../pageSales/ClientAnalyze.vue'),
      meta: { keepAlive: false, title: '客户分析' },
      name: "ClientAnalyze"
    },
    {
      path: '/Authorization',
      component: () =>
        import('../pageSales/Authorization.vue'),
      meta: { keepAlive: false, title: '授权' },
      name: "Authorization"
    },
    {
      path: '/Receivables',
      component: () =>
        import('../pageSales/Receivables.vue'),
      meta: { keepAlive: false, title: '应收款' },
      name: "Receivables"
    },
    {
      path: '/Royalty',
      component: () =>
        import('../pageSales/Royalty.vue'),
      meta: { keepAlive: false, title: '我的提成' },
      name: "Royalty"
    },

    //新增路由，重新账单功能 start
    {
      path: '/bill',
      component: () =>
        import('../pageSales/bill.vue'),
      meta: { keepAlive: false, title: '账单' },
      name: "bill"
    },
    {
      path: '/monthBill',
      component: () =>
        import('../pageSales/monthBill.vue'),
      meta: { keepAlive: false, title: '月账单' },
      name: "monthBill"
    },
    {
      path: '/monthBillClient',
      component: () =>
        import('../pageSales/monthBillClient.vue'),
      meta: { keepAlive: false, title: '月账单' },
      name: "monthBillClient"
    },
    {
      path: '/monthBillDebt',
      component: () =>
        import('../pageSales/monthBillDebt.vue'),
      meta: { keepAlive: false, title: '欠款订单' },
      name: "monthBillDebt"
    },
    {
      path: '/monthBillReturnMoney',
      component: () =>
        import('../pageSales/monthBillReturnMoney.vue'),
      meta: { keepAlive: false, title: '回款订单' },
      name: "monthBillReturnMoney"
    },
    {
      path: '/billDetails',
      component: () =>
        import('../pageSales/billDetails.vue'),
      meta: { keepAlive: false, title: '账单详情' },
      name: "billDetails"
    },
    {
      path: '/payPage',
      component: () =>
        import('../pageSales/payPage.vue'),
      meta: { keepAlive: false, title: '付款' },
      name: "payPage"
    },
    {
      path: '/paymentDocument',
      component: () =>
        import('../pageSales/paymentDocument.vue'),
      meta: { keepAlive: false, title: '确定支付' },
      name: "paymentDocument"
    },

    {
      path: '/orderDetails',
      component: () =>
        import('../pageSales/orderDetails.vue'),
      meta: { keepAlive: false, title: '订单详情' },
      name: "orderDetails"
    },




    //新增路由，重新账单功能 end




    {
      path: '/pickApple',
      component: () =>
        import('../pageSales/pickApple.vue'),
      meta: { keepAlive: false, title: '提货申请' },
      name: "pickApple"
    },
    {
      path: '/pickApple_new',
      component: () =>
        import('../pageSales/pickApple_new.vue'),
      meta: { keepAlive: false, title: '调拨申请' },
      name: "pickApple_new"
    },
    {
      path: '/warehouse',
      component: () =>
        import('../pageSales/warehouse.vue'),
      meta: { keepAlive: false, title: '调拨申请' },
      name: "warehouse"
    },
    {
      path: '/placeOrderWarehouse',
      component: () =>
        import('../components/placeOrderWarehouse.vue'),
      meta: { keepAlive: false, title: '选择下单仓库' },
      name: "placeOrderWarehouse"
    },

    {
      path: '/enterwarehouse',
      component: () =>
        import('../pageSales/enterwarehouse.vue'),
      meta: { keepAlive: false, title: '调拨申请' },
      name: "enterwarehouse"
    },
    {
      path: '/allotDetails',
      component: () =>
        import('../pageSales/allotDetails.vue'),
      meta: { keepAlive: false, title: '调拨详情' },
      name: "allotDetails"
    },
    {
      path: '/deliveryRecord',
      component: () =>
        import('../pageSales/deliveryRecord.vue'),
      meta: { keepAlive: false, title: '出库记录' },
      name: "deliveryRecord"
    },
    {
      path: '/stockDetails',
      component: () =>
        import('../pageSales/stockDetails.vue'),
      meta: { keepAlive: false, title: '出库详情' },
      name: "stockDetails"
    },
    {
      path: '/putRecord',
      component: () =>
        import('../pageSales/putRecord.vue'),
      meta: { keepAlive: false, title: '入库记录' },
      name: "putRecord"
    },
    {
      path: '/putDetails',
      component: () =>
        import('../pageSales/putDetails.vue'),
      meta: { keepAlive: false, title: '入库详情' },
      name: "putDetails"
    },

    // {
    //   path: '/IndividualWarehouses/:warehouseId',
    //   component: () =>
    //     import('../pageSales/IndividualWarehouses.vue'),
    //   meta: { keepAlive: false, title: '个人仓库' },
    //   name: "IndividualWarehouses"
    // },
    {
      path: '/IndividualWarehouses',
      component: () =>
        import('../storehouse/stock.vue'),
      meta: { keepAlive: false, title: '个人仓库' },
      name: "IndividualWarehouses"
    },
    {
      path: '/warehouseInventory',
      component: () =>
        import('../pageSales/warehouseInventory.vue'),
      meta: { keepAlive: false, title: '库存查询' },
      name: "warehouseInventory"
    },
    {
      path: '/totalWarehouse/:warehouseId',
      component: () =>
        import('../pageSales/totalWarehouse.vue'),
      meta: { keepAlive: false, title: '商品' },
      name: "totalWarehouse"
    },
    {
      path: '/documentsReview',
      // component:IndividualWarehouse,
      component: () =>
        import('../pageSales/documentsReview.vue'),
      meta: { keepAlive: false, title: '盘点单据' },
      name: "documentsReview"
    },
    {
      path: '/checkDetails',
      // component:IndividualWarehouse,
      component: () =>
        import('../pageSales/checkDetails.vue'),
      meta: { keepAlive: false, title: '盘点详情' },
      name: "checkDetails"
    },
    {
      path: '/salesReturnBill',
      // component:IndividualWarehouse,
      component: () =>
        import('../pageSales/salesReturnBill.vue'),
      meta: { keepAlive: false, title: '退货单' },
      name: "salesReturnBill"
    },
    {
      path: '/salesReturnDetails',
      // component:IndividualWarehouse,
      component: () =>
        import('../pageSales/salesReturnDetails.vue'),
      meta: { keepAlive: false, title: '退货详情' },
      name: "salesReturnDetails"
    },
    {
      path: '/salesSellBill',
      // component:IndividualWarehouse,
      component: () =>
        import('../pageSales/salesSellBill.vue'),
      meta: { keepAlive: false, title: '销售单' },
      name: "salesSellBill"
    },
    {
      path: '/salesSellDetails',
      // component:IndividualWarehouse,
      component: () =>
        import('../pageSales/salesSellDetails.vue'),
      meta: { keepAlive: false, title: '销售详情' },
      name: "salesSellDetails"
    },
    {
      path: '/pickApple',
      component: () =>
        import('../pageSales/pickApple.vue'),
      meta: { keepAlive: false, title: '提货申请' },
      name: "pickApple"
    },
    {
      path: '/pickGoodsRecord/',
      component: () =>
        import('../pageSales/pickGoodsRecord.vue'),
      meta: { keepAlive: false, title: '提货申请记录' },
      name: "pickGoodsRecord"
    },
    {
      path: '/goodsRecordDetail/:person_warehouse_goods_id',
      component: () =>
        import('../pageSales/goodsRecordDetail.vue'),
      meta: { keepAlive: false, title: '提货申请记录详情' },
      name: "goodsRecordDetail"
    },
    {
      path: '/goodsReturnDetail/:person_warehouse_goods_back_id',
      component: () =>
        import('../pageSales/goodsReturnDetail.vue'),
      meta: { keepAlive: false, title: '回库申请记录详情' },
      name: "goodsReturnDetail"
    },
    {
      path: '/pickPhoto/:person_warehouse_goods_id',
      component: () =>
        import('../pageSales/pickPhoto.vue'),
      meta: { keepAlive: false, title: '提货拍照' },
      name: "pickPhoto"
    },
    {
      path: '/pickPhotoRecord',
      component: () =>
        import('../pageSales/pickPhotoRecord.vue'),
      meta: { keepAlive: false, title: '提货拍照记录' },
      name: "pickPhotoRecord"
    },
    {
      path: '/pickPhotoDetail/:person_warehouse_goods_id',
      component: () =>
        import('../pageSales/pickPhotoDetail.vue'),
      meta: { keepAlive: false, title: '提货拍照详情' },
      name: "pickPhotoDetail"
    },
    {
      path: '/backStoreApple',
      component: () =>
        import('../pageSales/backStoreApple.vue'),
      meta: { keepAlive: false, title: '回库申请' },
      name: "backStoreApple"
    },
    {
      path: '/backApple/:type',
      component: () =>
        import('../pageSales/backApple.vue'),
      meta: { keepAlive: false, title: '回库申请' },
      name: "backApple"
    },
    {
      path: '/personList/:salesman_id',
      component: () =>
        import('../components/personList.vue'),
      meta: { keepAlive: false, title: '个人仓库分类' },
      name: "personList"
    },
    {
      path: '/addBackGoods/:type/:warehouseId',
      component: () =>
        import('../pageSales/addBackGoods.vue'),
      meta: { keepAlive: false, title: '添加回库商品' },
      name: "addBackGoods"
    },
    {
      path: '/backGoodsRecord',
      component: () =>
        import('../pageSales/backGoodsRecord.vue'),
      meta: { keepAlive: false, title: '回库申请记录' },
      name: "backGoodsRecord"
    },
    {
      path: '/privateStore',
      component: () =>
        import('../pageSales/privateStore.vue'),
      meta: { keepAlive: false, title: ' 个人仓库' },
      name: "privateStore"
    },
    {
      path: '/privateErpStore',
      component: () =>
        import('../pageSales/privateErpStore.vue'),
      meta: { keepAlive: false, title: '库存查询' },
      name: "privateErpStore"
    },
    {
      path: '/privateErpStoreDetail/:id',
      component: () =>
        import('../pageSales/privateErpStoreDetail.vue'),
      meta: { keepAlive: false, title: '商品库存' },
      name: "privateErpStoreDetail"
    },
    {
      path: '/addShop/:warehouseId',
      component: () =>
        import('../pageSales/addShop.vue'),
      meta: { keepAlive: false, title: ' 添加商品' },
      name: "addShop"
    },
    {
      path: '/carCheck/:type',
      component: () =>
        import('../pageSales/carCheck.vue'),
      meta: { keepAlive: false, title: '车辆盘点' },
      name: "carCheck"
    },
    {
      path: '/checkRecord',
      component: () =>
        import('../pageSales/checkRecord.vue'),
      meta: { keepAlive: false, title: '盘点记录' },
      name: "checkRecord"
    },
    {
      path: '/checkDetail/:person_warehouse_inventory_id',
      component: () =>
        import('../pageSales/checkDetail.vue'),
      meta: { keepAlive: false, title: '盘点详情' },
      name: "checkDetail"
    },
    {
      path: '/addCheckShop',
      component: () =>
        import('../pageSales/addCheckShop.vue'),
      meta: { keepAlive: false, title: '添加盘点商品' },
      name: "addCheckShop"
    },
    {
      path: '/salesmanNews',
      component: () =>
        import('../pageSales/salesmanNews.vue'),
      meta: { keepAlive: false, title: '业务消息' },
      name: "salesmanNews"
    },
    {
      path: '/norFinishWork',
      component: () =>
        import('../pageSales/norFinishWork.vue'),
      meta: { keepAlive: false, title: '未处理的工作' },
      name: "norFinishWork"
    },
    {
      path: '/salesOrderDetail/:moid',
      component: () =>
        import('../pageSales/salesOrderDetail.vue'),
      meta: { keepAlive: false, title: '订单详情' },
      name: "salesOrderDetail"
    },
    {
      path: '/memberDetail/:memberDetailId',
      component: () =>
        import('../pageSales/memberDetail.vue'),
      meta: { keepAlive: false, title: '成员详情' },
      name: "memberDetail"
    },
    {
      path: '/accountDetail/:accountDetailId',
      component: () =>
        import('../pageSales/accountDetail.vue'),
      meta: { keepAlive: false, title: '客户账单明细' },
      name: "accountDetail"
    },
    {
      path: '/returnDetail/:returnDetailId',
      component: () =>
        import('../pageSales/returnDetail.vue'),
      meta: { keepAlive: false, title: '回款详情' },
      name: "returnDetail"
    },
    {
      path: '/orderDetail2/:orderDetailId',
      component: () =>
        import('../pageSales/orderDetail2.vue'),
      meta: { keepAlive: false, title: '订单详情' },
      name: "orderDetail2"
    },
    {
      path: '/debtAnalyze',
      component: () =>
        import('../pageSales/debtAnalyze.vue'),
      meta: { keepAlive: false, title: '账单分析' },
      name: "debtAnalyze"
    },
    {
      path: '/fenchengAnalyze',
      component: () =>
        import('../pageSales/fenchengAnalyze.vue'),
      meta: { keepAlive: false, title: '分成分析' },
      name: "fenchengAnalyze"
    },
    {
      path: '/fenchengDetail/:salesmanId',
      component: () =>
        import('../pageSales/fenchengDetail.vue'),
      meta: { keepAlive: false, title: '分成明细' },
      name: "fenchengDetail"
    },
    {
      path: '/orderStatistics',
      component: () =>
        import('../pageSales/orderStatistics.vue'),
      meta: { keepAlive: false, title: '订单统计' },
      name: "orderStatistics"
    },
    {
      path: '/selectSalesman',
      component: () =>
        import('../pageSales/selectSalesman.vue'),
      meta: { keepAlive: false, title: '选择提醒成员' },
      name: "selectSalesman"
    },
    //billbar
    {
      path: '/myApproval',
      component: () =>
        import('../pageSales/myApproval.vue'),
      meta: { keepAlive: false, title: '需要审核报销单' },
      name: "myApproval"
    },
    {
      path: '/hasSubmit',
      component: () =>
        import('../pageSales/hasSubmit.vue'),
      meta: { keepAlive: false, title: '已提交的报销单' },
      name: "hasSubmit"
    },

    {
      path: '/addConsume',
      component: () =>
        import('../pageSales/addConsume.vue'),
      meta: { keepAlive: false, title: '新建消费记录' },
      name: "addConsume"
    },
    {
      path: '/editConsume/:id',
      component: () =>
        import('../pageSales/editConsume.vue'),
      meta: { keepAlive: false, title: '编辑消费记录' },
      name: "editConsume"
    },
    {
      path: '/consumeType',
      component: () =>
        import('../pageSales/consumeType.vue'),
      meta: { keepAlive: false, title: '选择消费类型' },
      name: "consumeType"
    },
    {
      path: '/consumeClient',
      component: () =>
        import('../pageSales/consumeClient.vue'),
      meta: { keepAlive: false, title: '选择客户' },
      name: "consumeClient"
    },
    {
      path: '/createBill',
      component: () =>
        import('../pageSales/createBill.vue'),
      meta: { keepAlive: false, title: '新建报销单' },
      name: "createBill"
    },
    {
      path: '/createNewBill/:price',
      component: () =>
        import('../pageSales/createNewBill.vue'),
      meta: { keepAlive: false, title: '编辑报销单' },
      name: "createNewBill"
    },
    {
      path: '/billDetail/:orderId',
      component: () =>
        import('../pageSales/billDetail.vue'),
      meta: { keepAlive: false, title: '报销单详情' },
      name: "billDetail"
    },
    {
      path: '/billDetail1/:orderId',
      component: () =>
        import('../pageSales/billDetail1.vue'),
      meta: { keepAlive: false, title: '报销单详情' },
      name: "billDetail1"
    },
    {
      path: '/billAnalyze',
      component: () =>
        import('../pageSales/billAnalyze.vue'),
      meta: { keepAlive: false, title: '报销单分析' },
      name: "billAnalyze"
    },
    {
      path: '/teamRoyaltyAnalyze',
      component: () =>
        import('../pageSales/teamRoyaltyAnalyze.vue'),
      meta: { keepAlive: false, title: '团队提成分析' },
      name: "teamRoyaltyAnalyze"
    },
    {
      path: '/workVisitDetail/:workVisitDetailId',
      component: () =>
        import('../pageSales/workVisitDetail.vue'),
      meta: { keepAlive: false, title: '外勤拜访详情' },
      name: "workVisitDetail"
    },
    {
      path: '/selectFollowType',
      component: () =>
        import('../pageSales/selectFollowType.vue'),
      meta: { keepAlive: false, title: '选择跟进类型' },
      name: "selectFollowType"
    },
    // {
    //   path:'/addConmunicat/:ConmunicatId',
    //   component:()=>import('../pageSales/addConmunicat.vue'),
    //   meta:{keepAlive:false,title:'添加会话沟通'},
    //   name:"addConmunicat"
    //   },
    {
      path: '/addConmunicat1',
      component: () =>
        import('../pageSales/addConmunicat1.vue'),
      meta: { keepAlive: false, title: '添加会话沟通' },
      name: "addConmunicat1"
    },
    {
      path: '/addConmunicat1',
      component: () =>
        import('../pageSales/addConmunicat1.vue'),
      meta: { keepAlive: false, title: '添加会话沟通' },
      name: "addConmunicat1"
    },

    {
      path: '/addWorkVisit/:WorkVisitId',
      component: () =>
        import('../pageSales/addWorkVisit.vue'),
      meta: { keepAlive: false, title: '添加外勤拜访' },
      name: "addWorkVisit"
    },
    {
      path: '/beganVisit',
      component: () =>
        import('../pageSales/beganVisit.vue'),
      meta: { keepAlive: false, title: '新建外勤拜访' },
      name: "beganVisit"
    },
    {
      path: '/addVisit',
      component: () =>
        import('../pageSales/addVisit.vue'),
      meta: { keepAlive: false, title: '新建外勤拜访' },
      name: "addVisit"
    },
    {
      path: '/editVisit',
      component: () =>
        import('../pageSales/editVisit.vue'),
      meta: { keepAlive: false, title: '编辑外勤拜访' },
      name: "editVisit"
    },
    {
      path: '/saleSet',
      component: () =>
        import('../pageSales/saleSet.vue'),
      meta: { keepAlive: false, title: '设置' },
      name: "saleSet"
    },
    {
      path: '/changeAccount',
      component: () =>
        import('../pageSales/changeAccount.vue'),
      meta: { keepAlive: false, title: '账号安全' },
      name: "changeAccount"
    },
    {
      path: '/ChangeLoginPwd',
      component: () =>
        import('../pageSales/ChangeLoginPwd.vue'),
      meta: { keepAlive: false, title: '修改登录密码' },
      name: "ChangeLoginPwd"
    },
    {
      path: '/ChangePhone',
      component: () =>
        import('../pageSales/ChangePhone.vue'),
      meta: { keepAlive: false, title: '更换手机号' },
      name: "ChangePhone"
    },
    {
      path: '/changeNumber',
      component: () =>
        import('../pageSales/changeNumber.vue'),
      meta: { keepAlive: false, title: '更换手机号' },
      name: "changeNumber"
    },
    {
      path: '/foundPwd',
      component: () =>
        import('../pageSales/foundPwd.vue'),
      meta: { keepAlive: false, title: '找回登录密码' },
      name: "foundPwd"
    },
    {
      path: '/printSet',
      component: () =>
        import('../pageSales/printSet.vue'),
      meta: { keepAlive: false, title: '打印设置' },
      name: "printSet"
    },
    {
      path: '/equipmentSet',
      component: () =>
        import('../pageSales/equipmentSet.vue'),
      meta: { keepAlive: false, title: '设备设置' },
      name: "equipmentSet"
    },
    {
      path: '/sizeSet',
      component: () =>
        import('../pageSales/sizeSet.vue'),
      meta: { keepAlive: false, title: '尺寸设置' },
      name: "sizeSet"
    },
    {
      path: '/norAccoutAnalyze',
      component: () =>
        import('../pageSales/norAccoutAnalyze.vue'),
      meta: { keepAlive: false, title: '未还款金额' },
      name: "norAccoutAnalyze"
    },
    {
      path: '/accoutAnalyze',
      component: () =>
        import('../pageSales/accoutAnalyze.vue'),
      meta: { keepAlive: false, title: '已还款金额' },
      name: "accoutAnalyze"
    },

    {
      path: '/drawManage',
      component: () =>
        import('../pageSales/drawManage.vue'),
      meta: { keepAlive: false, title: '添加银行卡' },
      name: "drawManage"
    },
    {
      path: '/writeNews',
      component: () =>
        import('../pageSales/writeNews.vue'),
      meta: { keepAlive: false, title: '填写银行卡信息' },
      name: "writeNews"
    },
    {
      path: '/checkPhone',
      component: () =>
        import('../pageSales/checkPhone.vue'),
      meta: { keepAlive: false, title: '验证手机号' },
      name: "checkPhone"
    },
    {
      path: '/bangdingCard',
      component: () =>
        import('../pageSales/bangdingCard.vue'),
      meta: { keepAlive: false, title: '实名绑卡' },
      name: "bangdingCard"
    },
    {
      path: '/widthDraw',
      component: () =>
        import('../pageSales/widthDraw.vue'),
      meta: { keepAlive: false, title: '提现' },
      name: "widthDraw"
    },
    {
      path: '/widthDrawRecord',
      component: () =>
        import('../pageSales/widthDrawRecord.vue'),
      meta: { keepAlive: false, title: '提现记录' },
      name: "widthDrawRecord"
    },

    {
      path: '/widthDrawDtail',
      component: () =>
        import('../pageSales/widthDrawDtail.vue'),
      meta: { keepAlive: false, title: '提现明细' },
      name: "widthDrawDtail"
    },
    {
      path: '/personageNews',
      component: () =>
        import('../pageSales/personageNews.vue'),
      meta: { keepAlive: false, title: '个人信息' },
      name: "personageNews"
    },
    {
      path: '/setGrade',
      component: () =>
        import('../pageSales/setGrade.vue'),
      meta: { keepAlive: false, title: '等级' },
      name: "setGrade"
    },
    {
      path: '/createClientTip',
      component: () =>
        import('../pageSales/createClientTip.vue'),
      meta: { keepAlive: false, title: '新建回访提醒' },
      name: "createClientTip"
    },
    {
      path: '/clientInformation/:merchantId',
      component: () =>
        import('../pageSales/clientInformation.vue'),
      meta: { keepAlive: false, title: '客户信息' },
      name: "clientInformation"
    },
    {
      path: '/clientInformation_new/:merchantId',
      component: () =>
        import('../pageSales/clientInformation_new.vue'),
      meta: { keepAlive: false, title: '客户信息' },
      name: "clientInformation_new"
    },
    {
      path: '/bebtOrder',
      component: () =>
        import('../pageSales/bebtOrder.vue'),
      meta: { keepAlive: false, title: '欠款' },
      name: "bebtOrder"
    },
    {
      path: '/shopFrontPicture',
      component: () =>
        import('../pageSales/shopFrontPicture.vue'),
      meta: { keepAlive: false, title: '门头照片' },
      name: "shopFrontPicture"
    },
    {
      path: '/invoicesPicture',
      component: () =>
        import('../pageSales/invoicesPicture.vue'),
      meta: { keepAlive: false, title: '单据照片' },
      name: "invoicesPicture"
    },
    {
      path: '/clientNewsDetail/:clientNewsDetailId',
      component: () =>
        import('../pageSales/clientNewsDetail.vue'),
      meta: { keepAlive: false, title: '客户详情' },
      name: "clientNewsDetail"
    },
    {
      path: '/editNews',
      component: () =>
        import('../pageSales/editNews.vue'),
      meta: { keepAlive: false, title: '编辑客户' },
      name: "editNews"
    },
    {
      path: '/storeSell',
      component: () =>
        import('../pageSales/storeSell.vue'),
      meta: { keepAlive: false, title: '客户' },
      name: "storeSell"
    },
    {
      path: '/buyType',
      component: () =>
        import('../pageSales/buyType.vue'),
      meta: { keepAlive: false, title: '下单方式' },
      name: "buyType"
    },
    {
      path: '/changeOrder/:changeOrderId',
      component: () =>
        import('../pageSales/changeOrder.vue'),
      meta: { keepAlive: false, title: '订单修改' },
      name: "changeOrder"
    },
    {
      path: '/returnOrderList/:returnOrderId',
      component: () =>
        import('../pageSales/returnOrderList.vue'),
      meta: { keepAlive: false, title: '退货清单' },
      name: "returnOrderList"
    },
    {
      path: '/returnCheck/:returnOrderId',
      component: () =>
        import('../pageSales/returnCheck.vue'),
      meta: { keepAlive: false, title: '退货盘点' },
      name: "returnCheck"
    },


    //商家端
    {
      path: '/merConfirmOrder',
      component: () =>
        import('../merchantPages/merConfirmOrder.vue'),
      meta: { keepAlive: false, title: '确认订单--商家端' },
      name: "merConfirmOrder"
    },
    {
      path: '/followCode',
      component: () =>
        import('../merchantPages/scanCode/followCode.vue'),
      meta: { keepAlive: false, title: '关注公众号' },
      name: "followCode"
    },
    {
      path: '/updateInfo/:uniq',
      component: () =>
        import('../merchantPages/scanCode/updateInfo.vue'),
      meta: { keepAlive: false, title: '修改信息' },
      name: "updateInfo"
    },
    {
      path: '/merUser',
      component: () =>
        import('../merchant/merUser.vue'),
      meta: { keepAlive: false, title: '我的', needrouter: true },
      name: "merUser"
    },
    {
      path: '/myRedPacket',
      component: () =>
        import('../merchantPages/myRedPacket.vue'),
      meta: { keepAlive: false, title: '我的红包' },
      name: "myRedPacket"
    },
    {
      path: '/redPacket',
      component: () =>
        import('../merchantPages/redPacket.vue'),
      meta: { keepAlive: false, title: '红包明细' },
      name: "redPacket"
    },
    {
      path: '/codeCard',
      component: () =>
        import('../merchantPages/codeCard.vue'),
      meta: { keepAlive: false, title: '我的二维码' },
      name: "codeCard"
    },
    {
      path: '/myWalt',
      component: () =>
        import('../merchantPages/myWalt.vue'),
      meta: { keepAlive: false, title: '我的钱包' },
      name: "myWalt"
    },
    {
      path: '/waltDetail',
      component: () =>
        import('../merchantPages/waltDetail.vue'),
      meta: { keepAlive: false, title: '钱包明细' },
      name: "waltDetail"
    },
    {
      path: '/merwidthdraw',
      component: () =>
        import('../merchantPages/merwidthdraw.vue'),
      meta: { keepAlive: false, title: '提现' },
      name: "merwidthdraw"
    },
    {
      path: '/merSet',
      component: () =>
        import('../merchantPages/merSet.vue'),
      meta: { keepAlive: false, title: '设置' },
      name: "merSet"
    },
    {
      path: '/storeMange',
      component: () =>
        import('../merchantPages/storeMange.vue'),
      meta: { keepAlive: false, title: '店铺资料' },
      name: "storeMange"
    },
    {
      path: '/merFans',
      component: () =>
        import('../merchantPages/merFans.vue'),
      meta: { keepAlive: false, title: '粉丝' },
      name: "merFans"
    },
    {
      path: '/merClient',
      component: () =>
        import('../merchantPages/merClient.vue'),
      meta: { keepAlive: false, title: '客户' },
      name: "merClient"
    },
    {
      path: '/messageSale',
      component: () =>
        import('../merchantPages/messageSale.vue'),
      meta: { keepAlive: false, title: '短信营销' },
      name: "messageSale"
    },
    {
      path: '/massmessage',
      component: () =>
        import('../merchantPages/massmessage.vue'),
      meta: { keepAlive: false, title: '群发短信' },
      name: "massmessage"
    },
    {
      path: '/messageTemplate',
      component: () =>
        import('../merchantPages/messageTemplate.vue'),
      meta: { keepAlive: false, title: '选择模板' },
      name: "messageTemplate"
    },
    {
      path: '/shopNotice',
      component: () =>
        import('../merchantPages/shopNotice.vue'),
      meta: { keepAlive: false, title: '店铺通知' },
      name: "shopNotice"
    },
    {
      path: '/messageRecharge',
      component: () =>
        import('../merchantPages/messageRecharge.vue'),
      meta: { keepAlive: false, title: '短信充值' },
      name: "messageRecharge"
    },
    {
      path: '/rechargePay',
      component: () =>
        import('../merchantPages/rechargePay.vue'),
      meta: { keepAlive: false, title: '短信充值' },
      name: "rechargePay"
    },
    {
      path: '/myAcount',
      component: () =>
        import('../merchantPages/myAcount.vue'),
      meta: { keepAlive: false, title: '我的账单' },
      name: "myAcount"
    },
    {
      path: '/merOrder',
      component: () =>
        import('../merchantPages/merOrder.vue'),
      meta: { keepAlive: false, title: '我的订单' },
      name: "merOrder"
    },
    {
      path: '/saleOrder',
      component: () =>
        import('../merchantPages/saleOrder.vue'),
      meta: { keepAlive: false, title: '售后订单' },
      name: "saleOrder"
    },
    {
      path: '/shopList',
      component: () =>
        import('../merchantPages/shopList.vue'),
      meta: { keepAlive: false, title: '店铺列表' },
      name: "shopList"
    },
    {
      path: '/clientOrder',
      component: () =>
        import('../merchantPages/clientOrder.vue'),
      meta: { keepAlive: false, title: '客户订单' },
      name: "clientOrder"
    },
    {
      path: '/merAddClient',
      component: () =>
        import('../merchantPages/merAddClient.vue'),
      meta: { keepAlive: false, title: '新增客户' },
      name: "merAddClient"
    },
    {
      path: '/merAcountDetail',
      component: () =>
        import('../merchantPages/merAcountDetail.vue'), 
      meta: { keepAlive: false, title: '账单明细' },
      name: "merAcountDetail"
    },
    {
      path: '/clientDetail',
      component: () =>
        import('../merchantPages/clientDetail.vue'),
      meta: { keepAlive: false, title: '客户详情' },
      name: "clientDetail"
    },
    {
      path: '/merStoreMange',
      component: () =>
        import('../merchantPages/merStoreMange.vue'),
      meta: { keepAlive: false, title: '店铺管理' },
      name: "merStoreMange"
    },
    {
      path: '/fansDetail',
      component: () =>
        import('../merchantPages/fansDetail.vue'),
      meta: { keepAlive: false, title: '粉丝详情' },
      name: "fansDetail"
    },
    {
      path: '/storeDetail/:merchant_id',
      component: () =>
        import('../merchantPages/storeDetail.vue'),
      meta: { keepAlive: false, title: '店铺详情' },
      name: "storeDetail"
    },
    {
      path: '/feeNeter',
      // component: () => import('../merchantPages/openRed.vue'),
      component: () =>
        import('../merchantPages/feeNeter.vue'),
      meta: { keepAlive: false, title: '免费入驻' },
      name: "feeNeter"
    },
    {
      path: '/openRed',
      component: () =>
        import('../merchantPages/openRed.vue'),
      // component: () => import('../merchantPages/feeNeter.vue'),
      meta: { keepAlive: false, title: '免费入驻' },
      name: "feeNeter"
    },
    {
      path: '/chooseClassify',
      component: () =>
        import('../merchantPages/chooseClassify.vue'),
      meta: { keepAlive: false, title: '选择分类' },
      name: "chooseClassify"
    },
    {
      path: '/limitSet',
      component: () =>
        import('../merchantPages/limitSet.vue'),
      meta: { keepAlive: false, title: '权限设置' },
      name: "limitSet"
    },
    {
      path: '/merSaleMange',
      component: () =>
        import('../merchantPages/merSaleMange.vue'),
      meta: { keepAlive: false, title: '售后管家' },
      name: "merSaleMange"
    },
    {
      path: '/saleServer/:status_id/:cons_addtime',
      component: () =>
        import('../merchantPages/saleServer.vue'),
      meta: { keepAlive: false, title: '申请售后' },
      name: "saleServer"
    },
    {
      path: '/saleTime',
      component: () =>
        import('../merchantPages/saleTime.vue'),
      meta: { keepAlive: false, title: '申请售后' },
      name: "saleTime"
    },
    {
      path: '/nearStore',
      component: () =>
        import('../merchantPages/nearStore.vue'),
      meta: { keepAlive: false, title: '附近门店' },
      name: "nearStore"
    },
    {
      path: '/chooseAddress',
      component: () =>
        import('../merchantPages/nearStore/chooseAddress.vue'),
      meta: { keepAlive: false, title: '选择地址' },
      name: "chooseAddress"
    },
    {
      path: '/searchShop',
      component: () =>
        import('../merchantPages/nearStore/searchShop.vue'),
      meta: { keepAlive: false, title: '搜索' },
      name: "searchShop"
    },
    {
      path: '/staffMange',
      component: () =>
        import('../shop/staffList.vue'),
      meta: { keepAlive: false, title: '员工管理' },
      name: "staffMange"
    },
    {
      path: '/addStaff',
      component: () =>
        import('../merchantPages/addStaff2.vue'),
      meta: { keepAlive: false, title: '添加员工' },
      name: "addStaff"
    },
    {
      path: '/updateStaff',
      component: () =>
        import('../merchantPages/updateStaff.vue'),
      meta: { keepAlive: false, title: '修改员工信息' },
      name: "updateStaff"
    },
    {
      path: '/staffDetail/:staffDetail',
      component: () =>
        import('../merchantPages/staffDetail.vue'),
      meta: { keepAlive: false, title: '员工详情' },
      name: "staffDetail"
    },
    {
      path: '/editorNameCard/:editorNameCard',
      component: () =>
        import('../merchantPages/editorNameCard.vue'),
      meta: { keepAlive: false, title: '名片编辑' },
      name: "editorNameCard"
    },
    {
      path: '/addNameCard',
      component: () =>
        import('../merchantPages/addNameCard.vue'),
      meta: { keepAlive: false, title: '创建名片' },
      name: "addNameCard"
    },
    {
      path: '/openNameCard',
      component: () =>
        import('../merchantPages/openNameCard.vue'),
      meta: { keepAlive: false, title: '创建名片' },
      name: "openNameCard"
    },
    {
      path: '/myNameCard',
      component: () =>
        import('../merchantPages/myNameCard.vue'),
      meta: { keepAlive: false, title: '我的名片' },
      name: "myNameCard"
    },
    {
      path: '/changeNameCard',
      component: () =>
        import('../merchantPages/changeNameCard.vue'),
      meta: { keepAlive: false, title: '修改名片' },
      name: "changeNameCard"
    },
    {
      path: '/saveNameCard',
      component: () =>
        import('../merchantPages/saveNameCard.vue'),
      meta: { keepAlive: false, title: '保存名片' },
      name: "saveNameCard"
    },
    {
      path: '/conffirmOrder/:conffirmOrderId',
      component: () =>
        import('../merchantPages/conffirmOrder.vue'),
      meta: { keepAlive: false, title: '确认订单' },
      name: "conffirmOrder"
    },
    {
      path: '/setLimit',
      component: () =>
        import('../merchantPages/setLimit.vue'),
      meta: { keepAlive: false, title: '权限设置' },
      name: "setLimit"
    },
    {
      path: '/signatrue',
      component: () =>
        import('../merchantPages/signatrue.vue'),
      meta: { keepAlive: false, title: '确认签收' },
      name: "signatrue"
    },
    {
      path: '/merSaleServer',
      component: () =>
        import('../merchantPages/merSaleServer.vue'),
      meta: { keepAlive: false, title: '售后服务' },
      name: "merSaleServer"
    },
    {
      path: '/signNameSuccess',
      component: () =>
        import('../merchantPages/signNameSuccess.vue'),
      meta: { keepAlive: false, title: '签名成功' },
      name: "signNameSuccess"
    },
    {
      path: '/merstoreManagement',
      component: () =>
        import('../merchantPages/merstoreManagement.vue'),
      meta: { keepAlive: false, title: '门店订单' },
      name: "merstoreManagement"
    },
    {
      path: '/exchangeShop',
      component: () =>
        import('../merchantPages/exchangeShop.vue'),
      meta: { keepAlive: false, title: '兑换商城' },
      name: "exchangeShop"
    },
    {
      path: '/preste',
      component: () =>
        import('../merchantPages/preset.vue'),
      meta: { keepAlive: false, title: '资金账户' },
      name: "preste"
    },
    {
      path: '/saveDetails',
      component: () =>
        import('../merchantPages/saveDetails.vue'),
      meta: { keepAlive: false, title: '预存款明细' },
      name: "saveDetails"
    },
    {
      path: '/storageMoney',
      component: () =>
        import('../merchantPages/storageMoney.vue'),
      meta: { keepAlive: false, title: '充值' },
      name: "storageMoney"
    },
    {
      path: '/payProof',
      component: () =>
        import('../merchantPages/payProof.vue'),
      meta: { keepAlive: false, title: '传支付凭证值' },
      name: "payProof"
    },

    //售后服务
    {
      path: '/battery',
      component: () =>
        import('../merchantPages/saleServer/battery.vue'),
      meta: { keepAlive: false, title: '充电类售后规则' },
      name: "battery"
    },
    {
      path: '/wire/:wireId',
      component: () =>
        import('../merchantPages/saleServer/wire.vue'),
      meta: { keepAlive: false, title: '线材类售后规则' },
      name: "wire"
    },
    {
      path: '/vehicle',
      component: () =>
        import('../merchantPages/saleServer/vehicle.vue'),
      meta: { keepAlive: false, title: '车载类售后规则' },
      name: "vehicle"
    },
    {
      path: '/frequency',
      component: () =>
        import('../merchantPages/saleServer/frequency.vue'),
      meta: { keepAlive: false, title: '音频类售后规则' },
      name: "frequency"
    },
    {
      path: '/exchangeCord',
      component: () =>
        import('../merchantPages/exchange/exchangeCord.vue'),
      meta: { keepAlive: false, title: '兑换记录' },
      name: "exchangeCord"
    },
    {
      path: '/packetRule',
      component: () =>
        import('../merchantPages/exchange/packetRule.vue'),
      meta: { keepAlive: false, title: '红包规则' },
      name: "packetRule"
    },
    {
      path: '/exchangeDetail/:exchangeDetailId',
      component: () =>
        import('../merchantPages/exchange/exchangeDetail.vue'),
      meta: { keepAlive: false, title: '兑换详情' },
      name: "exchangeDetail"
    },
    {
      path: '/exchangeOrder/:exchangeOrderId',
      component: () =>
        import('../merchantPages/exchange/exchangeOrder.vue'),
      meta: { keepAlive: false, title: '兑换详情' },
      name: "exchangeOrder"
    },
    {
      path: '/exchangeSuccess',
      component: () =>
        import('../merchantPages/exchange/exchangeSuccess.vue'),
      meta: { keepAlive: false, title: '兑换成功' },
      name: "exchangeSuccess"
    },
    {
      path: '/navDetail/:type_id',
      component: () =>
        import('../merchantPages/navDetail.vue'),
      meta: { keepAlive: false, title: '专卖店' },
      name: "navDetail"
    },


    //工作汇报
    {
      path: '/workReportHome',
      component: () =>
        import('../workReport/page/workReportHome.vue'),
      meta: { keepAlive: true, title: '工作汇报' },
      name: "workReportHome"
    },
    {
      path: '/lookReport',
      component: () =>
        import('../workReport/page/lookReport.vue'),
      meta: { keepAlive: false, title: '查看工作汇报' },
      name: "lookReport"
    },
    {
      path: '/lookReportList/:tabDate/:time',
      component: () =>
        import('../workReport/page/lookReportList.vue'),
      meta: { keepAlive: false, title: '工作汇报详情' },
      name: "lookReportList"
    },
    {
      path: '/lookWorkVisitDetail/:lookWorkVisitDetailId/:date',
      component: () =>
        import('../workReport/page/lookWorkVisitDetail.vue'),
      meta: { keepAlive: false, title: '工作汇报详情' },
      name: "lookWorkVisitDetail"
    },
    {
      path: '/reportSalesClient/:reportSalesClient/:date',
      component: () =>
        import('../workReport/page/reportSalesClient.vue'),
      meta: { keepAlive: false, title: '工作汇报客户' },
      name: "reportSalesClient"
    },
    {
      path: '/FieldVisit/:FieldVisitId/:date',
      component: () =>
        import('../workReport/page/FieldVisit.vue'),
      meta: { keepAlive: false, title: '工作汇报外勤拜访' },
      name: "FieldVisit"
    },
    {
      path: '/communicate',
      component: () =>
        import('../workReport/page/communicate.vue'),
      meta: { keepAlive: false, title: '工作汇报会话沟通' },
      name: "communicate"
    },
    {
      path: '/reportOrder/:reportOrder/:date',
      component: () =>
        import('../workReport/page/reportOrder.vue'),
      meta: { keepAlive: false, title: '订单' },
      name: "reportOrder"
    },
    {
      path: '/salesVolume',
      component: () =>
        import('../workReport/page/salesVolume.vue'),
      meta: { keepAlive: false, title: '销量' },
      name: "salesVolume"
    },
    {
      path: '/Collection/:Collection/:date',
      component: () =>
        import('../workReport/page/Collection.vue'),
      meta: { keepAlive: false, title: '回款' },
      name: "Collection"
    },
    {
      path: '/Date/:type/:id',
      component: () =>
        import('../workReport/page/Date.vue'),
      meta: { keepAlive: false, title: '日期' },
      name: "Date"
    },
    {
      path: '/CollectionCustomer/:return_merchant_ids',
      component: () =>
        import('../workReport/page/CollectionCustomer.vue'),
      meta: { keepAlive: false, title: '回款客户' },
      name: "CollectionCustomer"
    },
    {
      path: '/collectionOrder/:order_ids/:date',
      component: () =>
        import('../workReport/page/collectionOrder.vue'),
      meta: { keepAlive: false, title: '回款订单' },
      name: "collectionOrder"
    },
    {
      path: '/refund',
      component: () =>
        import('../workReport/page/refund.vue'),
      meta: { keepAlive: false, title: '退货' },
      name: "refund"
    },
    {
      path: '/RefundOrder',
      component: () =>
        import('../workReport/page/RefundOrder.vue'),
      meta: { keepAlive: false, title: '退货订单' },
      name: "RefundOrder"
    },
    {
      path: '/Share',
      component: () =>
        import('../workReport/page/Share.vue'),
      meta: { keepAlive: false, title: '分成' },
      name: "Share"
    },
    {
      path: '/setManage',
      component: () =>
        import('../workReport/page/setManage.vue'),
      meta: { keepAlive: false, title: '管理设置' },
      name: "setManage"
    },
    {
      path: '/showHistory',
      component: () =>
        import('../workReport/page/showHistory.vue'),
      meta: { keepAlive: false, title: '是否显示谁看过' },
      name: "showHistory"
    },
    {
      path: '/lookScope',
      component: () =>
        import('../workReport/page/lookScope.vue'),
      meta: { keepAlive: false, title: '允许谁看工作汇报' },
      name: "lookScope"
    },
    {
      path: '/reportStatistics/:type/:time',
      component: () =>
        import('../workReport/page/reportStatistics.vue'),
      meta: { keepAlive: false, title: '工作汇报统计' },
      name: "reportStatistics"
    },
    {
      path: '/statisticsDetail/:department_id/:type/:time/:is_write/:month/:timeDay/:department_name',
      component: () =>
        import('../workReport/page/statisticsDetail.vue'),
      meta: { keepAlive: false, title: '统计详情' },
      name: "statisticsDetail"
    },
    {
      path: '/monthCount/:month',
      component: () =>
        import('../workReport/page/monthCount.vue'),
      meta: { keepAlive: false, title: '日报月统计' },
      name: "monthCount"
    },
    {
      path: '/writeWorkReport/:writeWorkReportId/:date',
      component: () =>
        import('../workReport/page/writeWorkReport.vue'),
      meta: { keepAlive: true, title: '写工作汇报' },
      name: "writeWorkReport"
    },
    {
      path: '/selectBranch',
      component: () =>
        import('../workReport/page/selectBranch.vue'),
      meta: { keepAlive: false, title: '选择部门' },
      name: "selectBranch"
    },
    {
      path: '/personageReportDetail/:salesman_id/:date/:month',
      component: () =>
        import('../workReport/page/personageReportDetail.vue'),
      meta: { keepAlive: false, title: '日报月统计（个人）' },
      name: "personageReportDetail"
    },
    {
      path: '/selectMember',
      component: () =>
        import('../workReport/page/selectMember.vue'),
      meta: { keepAlive: false, title: '日报月统计（个人）' },
      name: "selectMember"
    },
    {
      path: '/selectMemberItem',
      component: () =>
        import('../workReport/page/selectMemberItem.vue'),
      meta: { keepAlive: false, title: '日报月统计（个人）' },
      name: "selectMemberItem"
    },

    // 欠款
    {
      path: '/debt',
      component: () =>
        import('../debt/index.vue'),
      meta: { keepAlive: false, title: '欠款' },
      name: "Debt"
    },
    {
      path: '/YearDebt',
      component: () =>
        import('../debt/yearDebt.vue'),
      meta: { keepAlive: false, title: '欠款' },
      name: "YearDebt"
    },
    {
      path: '/yearBill',
      component: () =>
        import('../debt/yearBill.vue'),
      meta: { keepAlive: false, title: '欠款' },
      name: "YearBill"
    },
    {
      path: '/newOrderDetails',
      component: () =>
        import('../debt/orderDetails.vue'),
      meta: { keepAlive: false, title: '订单详情' },
      name: "orderDetails"
    },
    {
      path: '/debtBill',
      component: () =>
        import('../debt/bill.vue'),
      meta: { keepAlive: false, title: '订单详情' },
      name: "bill"
    },
    {
      path: '/choicevisit',
      component: () =>
        import('../pageSales/visit/addvisit.vue'),
      meta: { keepAlive: false, title: '选择跟进方式' },
      name: "addvisit"
    },
    {
      path: '/minevisit',
      component: () =>
        import('../pageSales/visit/mine.vue'),
      meta: { keepAlive: false, title: '我可查看的跟进记录' },
      name: "minevisit"
    },
    {
      path: '/statisticsvisit',
      component: () =>
        import('../pageSales/visit/statistics.vue'),
      meta: { keepAlive: false, title: '统计' },
      name: 'statisticsvisit'
    },
    {
      path: '/visitList',
      component: () =>
        import('../pageSales/visit/list.vue'),
      meta: { keepAlive: false, title: '列表' },
      name: 'visitList'
    },
    {
      path: '/visitDetails',
      component: () =>
        import('../pageSales/visit/details.vue'),
      meta: { keepAlive: false, title: '详情' },
      name: 'visitDetails'
    },
    {
      path: '/myorder',
      component: () =>
        import('../merchantPages/order/index.vue'),
      meta: { keepAlive: false, title: '订单' },
      name: 'myorder'
    },
    {
      path: '/salesmanList',
      component: () =>
        import('../pageSales/visit/salesman_list.vue'),
      meta: { keepAlive: false, title: '业务员列表' },
      name: 'salesmanList'
    },
    {
      path: '/salesmanList2',
      component: () =>
        import('../pageSales/visit/salesman_list2.vue'),
      meta: { keepAlive: false, title: '业务员列表' },
      name: 'salesmanList'
    },
    {
      path: '/myAfr',
      component: () =>
        import('../pageSales/afr/index.vue'),
      meta: { keepAlive: false, title: '我的报销' },
      name: 'myAfr'
    },
    {
      path: '/addRecord',
      component: () =>
        import('../pageSales/afr/addRecord.vue'),
      meta: { keepAlive: false, title: '新建消费记录' },
      name: 'addRecord'
    },
    {
      path: '/spendingType',
      component: () =>
        import('../pageSales/afr/spendingType.vue'),
      meta: { keepAlive: false, title: '选择消费类型' },
      name: 'spendingType'
    },
    {
      path: '/myApplication',
      component: () =>
        import('../pageSales/afr/myApplication.vue'),
      meta: { keepAlive: false, title: '我提交的报销单' },
      name: 'myApplication'
    },
    {
      path: '/afrDetails',
      component: () =>
        import('../pageSales/afr/afrDetails.vue'),
      meta: { keepAlive: false, title: '报销单详情' },
      name: 'afrDetails'
    },
    {
      path: '/notApproved',
      component: () =>
        import('../pageSales/afr/notApproved.vue'),
      meta: { keepAlive: false, title: '需要我审批的报销单' },
      name: 'notApproved'
    },

    {
      path: '/addAfr',
      component: () =>
        import('../pageSales/afr/addAfr.vue'),
      meta: { keepAlive: false, title: '创建报销单' },
      name: 'addAfr'
    },
    {
      path: '/finishAdd',
      component: () =>
        import('../pageSales/afr/finishAdd.vue'),
      meta: { keepAlive: false, title: '新建报销单' },
      name: 'finishAdd'
    },
    {
      path: '/doneAfr',
      component: () =>
        import('../pageSales/afr/doneAfr.vue'),
      meta: { keepAlive: false, title: '已审核的报销' },
      name: 'doneAfr'
    },
    {
      path: '/contactPerson',
      component: () =>
        import('../pageSales/afr/contactPerson.vue'),
      meta: { keepAlive: false, title: '选择联系人' },
      name: 'contactPerson'
    },
    {
      path: '/afterSaleDetails',
      component: () =>
        import('../merchant/afterSaleDetails.vue'),
      meta: { keepAlive: false, title: '售后商品详情' },
      name: 'afterSaleDetails'
    },
    {
      path: '/addSubordinateClient',
      component: () =>
        import('../merchant/addClient.vue'),
      meta: { keepAlive: false, title: '售后商品详情' },
      name: 'addSubordinateClient'
    },
    {
      path: '/openweapp',
      component: () =>
        import('../merchant/openweapp.vue'),
      meta: { keepAlive: false, title: '售后商品详情' },
      name: 'openweapp'
    },
    {
      path: '/merchantList',
      component: () =>
        import('../merchant/merchantList.vue'),
      meta: { keepAlive: false, title: '客户列表' },
      name: 'merchantList'
    },
    {
      path: '/mynoeorder',
      component: () =>
        import('../debt/order.vue'),
      meta: { keepAlive: false, title: '订单详情' },
      name: 'mynoeorder'
    },
    {
      path: '/scancode',
      component: () =>
        import('../page/scancode/index.vue'),
      meta: { keepAlive: false, title: '扫码' },
      name: 'scancode'
    },
    {
      path: '/phoneLogin',
      component: () =>
        import('../login/phoneLogin.vue'),
      meta: { keepAlive: false, title: '登录' },
      name: 'phoneLogin'
    },
    {
      path: '/passwordLogin',
      component: () =>
        import('../login/passwordLogin.vue'),
      meta: { keepAlive: false, title: '登录' },
      name: 'passwordLogin'
    },
    {
      path: '/weixinLogin',
      component: () =>
        import('../login/weixinLogin.vue'),
      meta: { keepAlive: false, title: '登录' },
      name: 'weixinLogin'
    },
    {
      path: '/login',
      component: () =>
        import('../login/login.vue'),
      meta: { keepAlive: false, title: '登录' },
      name: 'login'
    },
    {
      path: '/updataPassword',
      component: () =>
        import('../login/updataPassword.vue'),
      meta: { keepAlive: false, title: '注册' },
      name: 'updataPassword'
    },
    {
      path: '/unbind',
      component: () =>
        import('../login/unbind.vue'),
      meta: { keepAlive: false, title: '绑定微信' },
      name: 'unbind'
    },
    {
      path: '/switchAccount',
      component: () =>
        import('../login/switchAccount.vue'),
      meta: { keepAlive: false, title: '切换账号' },
      name: 'switchAccount'
    },
    {
      path: '/addAccount',
      component: () =>
        import('../login/addAccount.vue'),
      meta: { keepAlive: false, title: '新增账号' },
      name: 'addAccount'
    },
    {
      path: '/editPassword',
      component: () =>
        import('../login/editPassword.vue'),
      meta: { keepAlive: false, title: '修改密码' },
      name: 'editPassword'
    },
    {
      path: '/submitOrder',
      component: () =>
        import('../order/submitOrder.vue'),
      meta: { keepAlive: false, title: '提交订单' },
      name: 'submitOrder'
    },
    {
      path: '/shoppingCart',
      component: () =>
        import('../order/shoppingCart.vue'),
      meta: { keepAlive: false, title: '购物车' },
      name: 'shoppingCart'
    },
    {
      path: '/mixed',
      component: () =>
        import('../order/mixed.vue'),
      meta: { keepAlive: false, title: '支付' },
      name: 'mixed'
    },
    {
      path: '/receiveRedPacket',
      component: () =>
        import('../luckymoney/index.vue'),
      meta: { keepAlive: false, title: '领取红包' },
      name: 'luckymoney'
    },
    {
      path: '/luckymoney',
      component: () =>
        import('../merchantPages/scanCode/receiveRedPacket.vue'),
      meta: { keepAlive: false, title: '领取红包' },
      name: "receiveRedPacket"
    },
    {
      path: '/analyze',
      component: () =>
        import('../goods/analyze.vue'),
      meta: { keepAlive: false, title: '拿货分析' },
      name: 'analyze'
    },
    {
      path: '/analyzeDetails',
      component: () =>
        import('../goods/details.vue'),
      meta: { keepAlive: false, title: '商品分析' },
      name: 'analyzeDetails'
    },
    {
      path: '/clientInfo',
      component: () =>
        import('../merchant/clientInfo.vue'),
      meta: { keepAlive: false, title: '客户详情' },
      name: 'clientInfo'
    },
    {
      path: '/routeList',
      component: () =>
        import('../planningroute/index.vue'),
      meta: { keepAlive: false, title: '路线列表' },
      name: 'routeList'
    },
    {
      path: '/routeSalesmanList',
      component: () =>
        import('../planningroute/salesmanList.vue'),
      meta: { keepAlive: false, title: '业务员列表' },
      name: 'routeSalesmanList'
    },
    {
      path: '/routeMerchantList',
      component: () =>
        import('../planningroute/merchantList.vue'),
      meta: { keepAlive: false, title: '客户列表' },
      name: 'routeMerchantList'
    },
    {
      path: '/addrouter',
      component: () =>
        import('../planningroute/addRouut.vue'),
      meta: { keepAlive: true, title: '新增路线' },
      name: 'addrouter'
    },
    {
      path: '/editrouter',
      component: () =>
        import('../planningroute/editRouter.vue'),
      meta: { keepAlive: true, title: '编辑路线' },
      name: 'editrouter'
    },
    {
      path: '/visitRecordList',
      component: () =>
        import('../planningroute/visitList.vue'),
      meta: { keepAlive: false, title: '跟进记录' },
      name: 'visitRecordList'
    },
    {
      path: '/visanalyze',
      component: () =>
        import('../planningroute/analyze.vue'),
      meta: { keepAlive: false, title: '拜访分析' },
      name: 'visanalyze'
    },
    {
      path: '/record',
      component: () =>
        import('../planningroute/record.vue'),
      meta: { keepAlive: false, title: '我可以查看的拜访记录' },
      name: 'record'
    },
    {
      path: '/routerAnalyze',
      component: () =>
        import('../planningroute/routerAnalyze.vue'),
      meta: { keepAlive: false, title: '路线拜访分析' },
      name: 'routerAnalyze'
    },
    {
      path: '/choiceMerchant',
      component: () =>
        import('../planningroute/choiceMerchant.vue'),
      meta: { keepAlive: false, title: '选择客户' },
      name: 'choiceMerchant'
    },
    {
      path: '/billList',
      component: () =>
        import('../bill/index.vue'),
      meta: { keepAlive: false, title: '账单' },
      name: 'choiceMerchant'
    },
    {
      path: '/monthBillList',
      component: () =>
        import('../bill/monthBill.vue'),
      meta: { keepAlive: false, title: '月账单' },
      name: 'choiceMerchant'
    },
    {
      path: '/billstatistics',
      component: () =>
        import('../bills/index.vue'),
      meta: { keepAlive: false, title: '我的账单' },
      name: 'billstatistics'
    },
    {
      path: '/monthsBill',
      component: () =>
        import('../bills/monthsBill.vue'),
      meta: { keepAlive: false, title: '订单佣金统计' },
      name: 'monthsBill'
    },
    {
      path: '/dayBill',
      component: () =>
        import('../bills/dayBill.vue'),
      meta: { keepAlive: false, title: '订单佣金统计' },
      name: 'dayBill'
    },
    {
      path: '/yearMonthBill',
      component: () =>
        import('../bills/yearMonthBill.vue'),
      meta: { keepAlive: false, title: '账单' },
      name: 'yearMonthBill'
    },
    {
      path: '/monthVisitReward',
      component: () =>
        import('../bills/monthVisitReward.vue'),
      meta: { keepAlive: false, title: '外勤补贴统计' },
      name: 'monthVisitReward'
    },
    {
      path: '/dayVisitReward',
      component: () =>
        import('../bills/dayVisitReward.vue'),
      meta: { keepAlive: false, title: '外勤补贴统计' },
      name: 'dayVisitReward'
    },
    {
      path: '/monthPhoneReward',
      component: () =>
        import('../bills/monthPhoneReward.vue'),
      meta: { keepAlive: false, title: '会话补贴统计' },
      name: 'monthPhoneReward'
    },
    {
      path: '/dayPhoneReward',
      component: () =>
        import('../bills/dayPhoneReward.vue'),
      meta: { keepAlive: false, title: '会话补贴统计' },
      name: 'dayPhoneReward'
    },
    {
      path: '/monthRechargeReward',
      component: () =>
        import('../bills/monthRechargeReward.vue'),
      meta: { keepAlive: false, title: '充值佣金' },
      name: 'monthRechargeReward'
    },
    {
      path: '/dayRechargeReward',
      component: () =>
        import('../bills/dayRechargeReward.vue'),
      meta: { keepAlive: false, title: '充值佣金' },
      name: 'dayRechargeReward'
    },
    {
      path: '/monthsRewardBill',
      component: () =>
        import('../bills/monthsRewardBill.vue'),
      meta: { keepAlive: false, title: '奖励补贴' },
      name: 'monthsRewardBill'
    },
    {
      path: '/dayRewardBill',
      component: () =>
        import('../bills/dayRewardBill.vue'),
      meta: { keepAlive: false, title: '奖励补贴' },
      name: 'dayRewardBill'
    },
    {
      path: '/monthillegalBill',
      component: () =>
        import('../bills/monthillegalBill.vue'),
      meta: { keepAlive: false, title: '违规扣款' },
      name: 'monthillegalBill'
    },
    {
      path: '/diyillegalBill',
      component: () =>
        import('../bills/diyillegalBill.vue'),
      meta: { keepAlive: false, title: '违规扣款' },
      name: 'diyillegalBill'
    },
    {
      path: '/settlement',
      component: () =>
        import('../bills/settlement.vue'),
      meta: { keepAlive: false, title: '结算明细' },
      name: 'settlement'
    },
    {
      path: '/withdrawal',
      component: () =>
        import('../bills/withdrawal.vue'),
      meta: { keepAlive: false, title: '结算' },
      name: 'withdrawal'
    },
    {
      path: '/bankCardList',
      component: () =>
        import('../bills/bankCardList.vue'),
      meta: { keepAlive: false, title: '银行卡' },
      name: 'bankCardList'
    },
    {
      path: '/addBankCard',
      component: () =>
        import('../bills/addBankCard.vue'),
      meta: { keepAlive: false, title: '添加银行卡' },
      name: 'addBankCard'
    },
    {
      path: "*",
      redirect: "/startupPage",
      meta: { title: '登录' },
    },
  ]
})


// WEBPACK FOOTER //
// ./src/router/index.js